import { render, staticRenderFns } from "./RoomSkeleton.vue?vue&type=template&id=1b7bcd0a&scoped=true&"
import script from "./RoomSkeleton.vue?vue&type=script&lang=js&"
export * from "./RoomSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./RoomSkeleton.vue?vue&type=style&index=0&id=1b7bcd0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7bcd0a",
  null
  
)

export default component.exports